"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { API_BASE } from "../../../../constants/config";
import useformatted from "../../../../utils/useformatted";
import { CardGrid } from "../CardGrid/CardGrid";
import styleCard from "../CardGrid/CardGrid.module.scss";
import style from "./MainGrid.module.scss";

export const MainGrid = ({ cards, principal }) => {
  const { formattedDate } = useformatted();
  const router = useRouter();
  return (
    <section className={style.mainGrid}>
      <ul className="container-blog">
        <li className={style.cardContainer}>
          <article
            className={style.principalCard}
            onClick={() => router.push(`/blog/${principal.slug}`)}
          >
            <picture>
              <img
                src={`${API_BASE}${principal.cover.data.attributes.url}`}
                className={style.cover}
                alt="cover"
              />
            </picture>
            <div className={style.cardContent}>
              <div className={style.data}>
                <ul>
                  {principal.categories.categories &&
                    principal.categories.categories.map((tag, index) => (
                      <li key={index} className={style.pill}>
                        {tag}
                      </li>
                    ))}
                </ul>
                <h3 className={style.title}>{principal.title}</h3>
              </div>
              <div className={style.info}>
                <Link
                  href={`/blog/author/${principal.author.data.attributes.slug}`}
                >
                  <picture>
                    <img
                      src={`${API_BASE}${principal.author.data.attributes.avatar.data.attributes.url}`}
                      className={style.avatar}
                      alt="avatar"
                    />
                  </picture>
                  <span className={style.author}>
                    {principal.author.data.attributes.name}
                  </span>
                </Link>
                <span className={style.date}>
                  {formattedDate(principal.createdAt)}
                </span>
              </div>
            </div>
          </article>
        </li>
        {cards.map((article, index) => (
          <li key={index} className={style.cardContainer}>
            <CardGrid
              article={article}
              date={formattedDate(article.attributes.createdAt)}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
